import { Box, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react'
import logo from '../images/logo.svg';
import customerLogos from '../images/customer-logos.svg';
import BaseAuthPage from './BaseAuthPage';

const SideContent = () => (
  <Box>
    <img src={logo} alt="Fixie" height="50px" />
    <Box sx={{ color: 'white', paddingRight: '6rem' }} display={{ xs: 'none', sm: 'block' }}>
      <Box my={3}>
        <Typography variant="h6" sx={{ lineHeight: 1.2, marginBottom: '0.5rem' }}>Static IP addresses</Typography>
        <Typography variant="body1">For outbound requests and connections</Typography>
      </Box>
      <Box my={3}>
        <Typography variant="h6" sx={{ lineHeight: 1.2, marginBottom: '0.5rem' }}>Language and platform agnostic</Typography>
        <Typography variant="body1">Connect to anywhere, from anywhere</Typography>
      </Box>
      <Box my={3}>
        <Typography variant="h6" sx={{ lineHeight: 1.2, marginBottom: '0.5rem' }}>Trusted by thousands of companies</Typography>
        <img src={customerLogos} alt="Customers include Rogers, Casper, Farmers Insurance, and Coupa" style={{ maxWidth: "100%", marginTop: '0.25rem' }} />
      </Box>
    </Box>
  </Box>
);

const AuthPage = (props: PropsWithChildren) => (
  <BaseAuthPage sideContent={<SideContent />}>
    {props.children}
  </BaseAuthPage>
);

export default AuthPage;
